import React, { useCallback, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import PropTypes from 'prop-types';
import PhotoSelectIcon from 'assets/photoSelect.png';

const FORMATS = {
  RECEIPT_UPLOAD: {
    JPEG: 'image',
    JPG: 'image',
    PNG: 'image',
    PDF: 'application',
  },
};

const useStyles = makeStyles((theme) => ({
  card: {
    padding: '12 22',
    backgroundColor: '#0a1730',
    overflow: 'auto',
  },
  light: {
    backgroundColor: '#0a1730',
    color: theme?.palette?.text?.main,
  },
  centered: {
    margin: 5,
    textAlign: 'center',
  },
  pickMediButton: {
    color: theme.palette.text.light,
    padding: 0,
    margin: '4px 0px 0px',
    backgroundColor: '#0076BB',
    '&:hover': {
      backgroundColor: '#F48120',
    },
    textAlign: 'center',
  },
  pickMediButtonDisabled: {
    color: `${theme.palette.text.secondary}!important`,
  },
  medium: {
    color: 'inherit',
    height: 35,
    width: 35,
    marginTop: '-3px',
  },
  menu: {
    backgroundColor: '#ffffff',
    color: '#000000',
  },
  menuItem: {
    backgroundColor: '#ffffff',
    color: '#000000',
  },
  menuItemSelected: {
    backgroundColor: '#666666',
    color: '#ffffff',
  },
}));

const PickMultipleMedia = ({
  handleChange,
  type,
  format,
  additional,
}) => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isAndroid = userAgent.indexOf('android') > -1;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const fileInput = React.useRef(null);
  const styles = useStyles();
  const [files, setFiles] = useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openCamera = () => {
    fileInput.current.setAttribute('capture', 'user');
    fileInput.current.click();
    setAnchorEl(null);
  };

  const browseFiles = () => {
    fileInput.current.removeAttribute('capture');
    fileInput.current.click();
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    if (isAndroid) {
      setAnchorEl(event.currentTarget);
    } else {
      fileInput.current.click();
    }
  };

  const onFileSelection = useCallback(
    ({ target }) => {
      const data = target.files;
      setFiles(data);
      const fArr = [];
      for (let i = 0; i < data.length; i += 1) {
        fArr.push({
          id: i + 1,
          blob: URL.createObjectURL(data[i]),
          metaData: data[i],
          selected: true,
          type,
        });
      }
      handleChange(fArr, !!additional);
    },
    [handleChange, additional, type],
  );
  const inputAttributes = isAndroid ? {
    'aria-controls': 'fade-menu',
    'aria-haspopup': 'true',
  } : { capture: 'user' };
  return (
    <form
      className={styles.centered}
    >
      <input
        accept={format.value.map((v) => {
        let prefix = type;
        if (FORMATS[type]) {
            const tmp = FORMATS[type];
            if (v && tmp[v.toUpperCase()]) {
            prefix = tmp[v.toUpperCase()];
            }
        }
        return `${prefix}/${v}`;
        }).join(',')}
        style={{ display: 'none' }}
        multiple={format.multiple}
        type='file'
        ref={fileInput}
        onChange={onFileSelection}
        disabled={additional !== undefined ? false : !!files}
      />
      <IconButton
        {...inputAttributes}
        classes={{ root: styles.pickMediButton, disabled: styles.pickMediButtonDisabled }}
        variant='contained'
        color='secondary'
        component='span'
        disabled={additional !== undefined ? false : !!files}
        onClick={handleClick}
        size='large'
      >
        <img alt='Select Asset' src={PhotoSelectIcon} className={styles.medium} />
      </IconButton>
      {isAndroid && (
        <Menu
          id='simple-menu'
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          variant='menu'
          TransitionComponent={Fade}
          classes={{ paper: styles.menu, root: styles.menu, selected: styles.menuItemSelected }}
        >
          <MenuItem classes={{ root: styles.menuItem, selected: styles.menuItemSelected }} onClick={openCamera}>Camera</MenuItem>
          <MenuItem classes={{ root: styles.menuItem, selected: styles.menuItemSelected }} onClick={browseFiles}>Browse</MenuItem>
        </Menu>
      )}
    </form>
  );
};

PickMultipleMedia.propTypes = {
  handleChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  format: PropTypes.object.isRequired,
  additional: PropTypes.any,
};

export default PickMultipleMedia;
